module.exports = __webpack_public_path__ + "img/black_belt.f8390684.svg";